import React from "react";
import { chakra } from "@chakra-ui/react";
import ReactDOM from "react-dom";
import VideoRecordingController from "./VideoRecordingController";
import Fade from "src/components/Fade";
import { useSelector } from "react-redux";
import { getVideoMode } from "src/duck/selectors";

const EnhancedVideo = chakra("video");

export default function RecordingInProgressView({
  mediaCapturer,
  videoStream,
  videoMode
}) {
  const { status } = mediaCapturer.state.recorder;
  const globalVideoMode = useSelector(getVideoMode);

  const videoRef = React.useRef();
  const portalContainer = React.useMemo(
    () => document.createElement("div"),
    []
  );

  React.useEffect(() => {
    window.document.body.append(portalContainer);
    return () => window.document.body.removeChild(portalContainer);
  }, [portalContainer]);

  React.useEffect(() => {
    if (videoRef.current == null) return;
    if (videoRef.current.srcObject !== videoStream) {
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream, status]);

  const view = (
    <>
      <Fade
        unmountOnExit
        in={status !== "initial" && status !== "finished"}
        duration={{
          enter: 0.3,
          exit: 0
        }}
      >
        <EnhancedVideo
          bg="#212121"
          objectFit={videoMode || globalVideoMode || "cover"}
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          ref={videoRef}
          autoPlay
          muted
        />
      </Fade>
      <VideoRecordingController mediaCapturer={mediaCapturer} />
    </>
  );

  return ReactDOM.createPortal(view, portalContainer);
}
